<template>
  <div>
    <v-dialog v-model="promissoryNote.model" width="600px">
      <v-card>
        <v-card-title>Validación del pagaré</v-card-title>
        <v-card-text>
          <v-row class="">
            <v-col cols="12">
              <simple-currency-input
                v-model="cRequested"
                label="Solicita línea de crédito del nuevo pagaré"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            :loading="promissoryNote.loading"
            @click="promissoryNote.model = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="promissoryNote.loading"
            color="primary"
            @click="acceptPNRequest()"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <promissory-note-table
      :items="items"
      :loading="loading"
      :role="roles.MANAGER"
      :with-filters="true"
      :with-title="true"
      :searchable="true"
      :headers="headers"
      @statusHasChanged="setStatus"
      @rejectPromissory="rejectPromissory"
      @approvePromissory="showPromissoryModal"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import axios from '@/plugins/axios';
  import { Roles } from '@/core/constants/roleConstants';

  import PromissoryNoteTable from './components/PromissoryNoteTable.vue';
  import SimpleCurrencyInput from '@/components/inputs/SimpleCurrencyInput.vue';

  export default {
    name: 'PromissoryNotes',
    components: { PromissoryNoteTable, SimpleCurrencyInput },
    data: () => ({
      loading: false,
      items: [],
      observationsModal: false,
      validationModal: false,
      observations: [],
      options: {},
      total: 0,
      status: [],
      params: {
        status: '',
        search: '',
        channel: '',
        role: '',
      },
      cRequested: null,
      promissory: {},
      promissoryNote: {
        loading: false,
        model: false,
      },
      headers: [
        { text: 'Fecha (dd/mm/aaaa)', value: 'created' },
        { text: 'Nº Cliente', value: 'customer_id' },
        {
          text: 'Nombre del cliente',
          value: 'customer_name',
          cellClass: 'text-nowrap ',
        },
        {
          text: 'Id asesor',
          align: 'start',
          sortable: false,
          cellClass: 'text-nowrap',
          value: 'seller_id',
        },
        {
          text: 'Nombre de asesor',
          align: 'start',
          sortable: false,
          cellClass: 'text-nowrap',
          value: 'seller_name',
        },
        {
          text: 'Firma de pagaré',
          align: 'start',
          sortable: false,
          cellClass: 'text-nowrap',
          value: 'promissory_note_date',
        },
        {
          text: 'Pagaré',
          align: 'start',
          sortable: false,
          value: 'promissory_note_amount',
        },
        {
          text: 'Línea de credito disponible',
          align: 'start',
          sortable: false,
          value: 'credit_line',
        },
        {
          text: 'L. Credito solicitada',
          align: 'start',
          sortable: false,
          value: 'credit_line_amount_requested',
        },

        { text: 'Estatus', value: 'status' },
        { text: 'Tipo de solicitud', value: 'request_type.description' },
        {
          text: 'Observaciones',
          value: 'comments',
          align: 'center',
        },
        { text: 'Archivos', value: 'files', cellClass: 'text-nowrap' },
        { text: 'Acciones', value: 'actions' },
      ],
    }),

    computed: {
      roles() {
        return Roles;
      },
      ...mapGetters({
        user: 'auth/user',
      }),
    },
    mounted() {
      this.params.role = Roles.MANAGER;
      const manager = this.$getLocalStorageManager();
      this.params.user = manager
        ? this.$getLocalStorageManager()
        : `${localStorage.getItem('username')}`;
    },
    methods: {
      setStatus(status) {
        this.params.status = status;
        this.loadPromissoryNotes();
      },
      async loadPromissoryNotes() {
        this.loading = true;
        this.items = [];

        const params = {
          user: this.params.user,
          role: this.params.role,
          channel: `${this.user.VTWEG}`,
          status: this.params.status,
        };
        try {
          const response = await axios.post(
            '/promissory-notes/requests/all',
            params
          );
          this.items = response.data;
        } catch (error) {
          this.$swal({
            title: 'Ocurrio un error al recuperar las solicitudes',
            text: 'Servicio no disponible, por favor intente más tarde',
            type: 'warning',
          });
        }
        this.loading = false;
      },
      validateAmount(amount) {
        if (amount >= 100000000) {
          this.$toast.warning('El monto máximo es: 10 Millones');
          return false;
        }
        return true;
      },
      async fetchUpdatePromissoryNoteData(params = {}) {
        try {
          this.promissoryNote.loading = true;
          await axios.put(
            `/promissory-notes/requests/update/${this.promissory.id}`,
            params
          );
        } catch (error) {
          this.$swal.fire({
            title: `${error}`,
            icon: 'warning',
            type: 'warning',
            confirmButtonText: 'Ok',
            confirmButtonColor: '#3085d6',
          });
          return false;
        }
        this.promissoryNote.loading = false;
        return true;
      },

      async acceptPNRequest() {
        const amount = this.cRequested;
        if (!this.validateAmount(amount)) {
          return;
        }
        const isUpdated = await this.fetchUpdatePromissoryNoteData({
          amount: amount,
          status: 'VOC',
        });
        if (isUpdated) {
          this.$swal.fire({
            title: 'La solicitud ha sido enviada a area de CRÉDITO Y COBRANZA',
            icon: 'success',
            type: 'success',
            confirmButtonText: 'Confirmar',
            confirmButtonColor: '#3085d6',
          });
          this.promissoryNote.model = false;
          this.loadPromissoryNotes();
        }
      },
      rejectPromissory(item) {
        this.promissory = item;
        this.$swal({
          title: 'Agrega tus comentarios/Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off',
          },
          showCancelButton: true,
          icon: 'error',
          confirmButtonText: 'Confirmar',
          confirmButtonColor: '#3085d6',
          showLoaderOnConfirm: true,
          preConfirm: async (comment) => {
            const params = {
              ...this.params,
              status: 'RBM',
              comment: comment,
            };
            const isUpdated = await this.fetchUpdatePromissoryNoteData(params);
            if (isUpdated) {
              this.$swal.fire({
                title: 'La solicitud ha sido rechazada',
                icon: 'success',
                type: 'success',
                confirmButtonText: 'Aceptar',
                confirmButtonColor: '#3085d6',
              });
              this.loadPromissoryNotes();
            }
          },
          allowOutsideClick: () => !this.$swal.isLoading(),
        });
      },
      showPromissoryModal(promissory) {
        this.promissory = promissory;
        this.cRequested = this.cleanCurrencyString(
          promissory.credit_line_amount_requested
        );
        this.promissoryNote.model = true;
      },
      cancelValidationModal() {
        this.promissory = {};
        this.validationModal = false;
      },
      cleanCurrencyString(currencyString) {
        if (!currencyString) {
          return null;
        }
        const amount = String(currencyString).replace(/[^\d.]/g, '');
        const newamount = parseFloat(amount);
        return isNaN(newamount) ? null : newamount;
      },
    },
  };
</script>
